/** Resumen de la asociación etapa → visita, sin React. */

export interface StageLike {
    emrProtocolVisitIdRelated?: number | null;
}

export interface StageLinkSummary {
    total: number;
    linked: number;
    unlinked: number;
}

export const isStageLinked = (stage: StageLike): boolean =>
    stage.emrProtocolVisitIdRelated !== undefined && stage.emrProtocolVisitIdRelated !== null;

export const summarizeStages = (stages: StageLike[] | null | undefined): StageLinkSummary => {
    const list = stages ?? [];
    const linked = list.filter(isStageLinked).length;
    return { total: list.length, linked, unlinked: list.length - linked };
};
